module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"row\"> <div class=\"col-auto\"> <h5><span class=\"fa fa-cc-")
    ; __append(escapeFn( locals.brandImgClass ))
    ; __append(" mr-1\"></span> <strong>")
    ; __append(escapeFn( locals.last4 ))
    ; __append("</strong></h5> </div> <div class=\"col\"> <div>")
    ; __append(escapeFn( locals.name ))
    ; __append("</div> <div class=\"small text-muted\">Name on Card</div> </div> <div class=\"col-3\"> <div>")
    ; __append(escapeFn( locals.exp_month + " / " + locals.exp_year ))
    ; __append("</div> <div class=\"small text-muted\">Expires On</div> </div> <div class=\"col-auto\"> <button type=\"button\" class=\"close remove_card\">&times;</button> </div> </div> <div class=\"recharge_settings\"></div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/billing/payment_methods/credit_card_details/template.ejs
// module id = 1253
// module chunks = 1